import { render, staticRenderFns } from "./eleDialog.vue?vue&type=template&id=501f8a51&scoped=true&"
import script from "./eleDialog.vue?vue&type=script&lang=js&"
export * from "./eleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f8a51",
  null
  
)

export default component.exports